import {LandingSection} from '@tempo/landing';
import {Box, HStack} from '@tempo/core';
import {Image} from '@app/components/Image';

export const FeatureGallery: React.FC = (props) => {
	return (
		<Box display={{base: 'none', md: 'block'}}>
			<LandingSection {...props}>
				<HStack spacing={16} justifyContent="flex-start" alignItems="start">
					<Image
						src="0a64577f6972d3404f73501140e22668.jpg"
						aspectRatio="788/1390"
						width="394px"
						height="695px"
						alt=""
						mt={44}
					/>
					<Image
						width="391px"
						height="695px"
						alt=""
						src="0beb67c9f6dedfe1d18c3be07816e622.jpg"
						aspectRatio="782/1390"
					/>
				</HStack>
			</LandingSection>
		</Box>
	);
};
